import React, {useEffect, useState} from 'react';
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import useAuth from "../../../hooks/useAuth";
import {getChartImplementationQuery, updateChartImplementationMutation} from "../../../gql/chartImplementationGql";
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';
import {Box, Button, Card, CardActions, CardContent, CircularProgress} from "@mui/material";
import localStrings from "../../../localStrings";
import enqueueSnackbarWithSound from "../../../utils/SnackBarWithSound";
import toast from "react-hot-toast";
import {
    getDataGridImplementationQuery,
    updateDataGridImplementationMutation
} from "../../../gql/dataGridImplementationGql";

function MdDescription({dataGridImplementationId, reloadTrigger}) {

    const {currentEstablishment, currentBrand} = useAuth();
    const mdParser = new MarkdownIt(/* Markdown-it options */);

    const [dataGridImplementation, setDataGridImplementation] = useState(null);
    const [mdContent, setMdContent] = useState(null);
    useEffect(() => {
        const loaData = async () => {
            let res =
                await executeQueryUtil(getDataGridImplementationQuery(dataGridImplementationId))
            setDataGridImplementation(res?.data?.getDataGridImplementation);
            setMdContent(res?.data?.getDataGridImplementation?.mdDescription);
        }
        loaData()
    }, [dataGridImplementationId]);

    function handleEditorChange({ html, text }) {
        setMdContent(text);
    }

    async function updateMdDescription(mdContent) {
        if (!currentBrand() || !currentEstablishment()) {
            return;
        }
        await executeMutationUtil(updateDataGridImplementationMutation(
            {
                ...dataGridImplementation,
                mdDescription: mdContent,
            }));
        reloadTrigger();
        enqueueSnackbarWithSound(toast, null, null,
            localStrings.notif.dataGridImplementationUpdated);

    }

    return (
        <Card>
            {/*<p>{JSON.stringify(dataGridImplementation|| {})}</p>*/}
            {/*MdDescription*/}

            <CardContent>
                <MdEditor
                    value={mdContent}
                    style={{ height: '500px' }}
                    renderHTML={text => mdParser.render(text)}
                    onChange={handleEditorChange} />
            </CardContent>

            <CardActions>
                <div style={{width: '100%'}}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            p: 1,
                            m: 1,
                            borderRadius: 1,
                        }}
                    >

                        <Box>

                            <Button
                                variant="contained"
                                onClick={async () => {updateMdDescription(mdContent)}}
                            >
                                {localStrings.update}
                            </Button>
                        </Box>
                    </Box>
                </div>
            </CardActions>

        </Card>
    )
}

export default MdDescription